module.exports = __webpack_public_path__ + "img/service_qr.d5fc67fd.png";